import React from 'react';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import '../../css/components/listAndCreate.css';

const styles = () => ({
  actions: {
    display: 'flex',
    gap: '8px'
  }
});

const DisplayAndCreate = props => {
  //Adding staticContext here so it does not get passed through as through to div as Dom element.
  const {
    title,
    createButtonText,
    extraActions,
    children,
    staticContext,
    classes,
    ...other
  } = props;
  return (
    <div {...other}>
      <Grid container justify="space-between" alignItems="center">
        <Grid item xs="auto">
          {title}
        </Grid>
        <Grid item xs="auto">
          <div className={classes.actions}>
            {extraActions}
            <Button
              id="create-btn"
              component={Link}
              to={`${props.match.url}/create`}
              variant="contained"
              color="primary"
            >
              {createButtonText}
            </Button>
          </div>
        </Grid>
      </Grid>
      <Paper elevation={1}>{children}</Paper>
    </div>
  );
};
export default withStyles(styles)(DisplayAndCreate);
